import Avatar from "./avatar";
import ButtonLink from "./button-link";
import classes from "../classes";
import { FormattedDollars, FormattedPoints } from "./formatted-currency";
import { Link } from "react-router-dom";
import LinkOrAnchor from "./link-or-anchor";
import NavLinks from "./nav-links";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function UserNav({ expanded, session, sessionLogout, setExpanded, users }) {
  var cx = classes({
    "nav_menu": true,
    "nav_menu--is-open": expanded
  });

  var user = users.get(session.get("user_id"));

  var depositLink = (window.env.showAccountPages) ? (
    <Link className="nav_link nav_link--cta" to="/deposit">
      Deposit
    </Link>
  ) : null;

  return (
    <nav className="nav">
      <ul className="nav_table">
        <li className="nav_item nav_item--logo">
          <LinkOrAnchor className="nav_logo" to={window.env.homepageUrl} />
        </li>

        <li className="nav_item">
          <NavLinks session={session} />
        </li>

        <li className="nav_item nav_item--username">
          <div className={cx}>
            <ButtonLink className="nav_menu-label" onClick={() => setExpanded(!expanded)}>
              <dl className="nav_username">
                <dt>
                  <Avatar tiny user={user} />
                </dt>

                <dd>
                  <span className="nav_link">
                    <span className="nav_username-label">
                      {session.get("user_name")}
                    </span>
                  </span>
                </dd>
              </dl>
            </ButtonLink>

            <div className="nav_menu-content">
              <ul className="nav_menu-list">
                <li className="nav_menu-item--info nav_menu-item--border-bottom">
                  <ButtonLink className="nav_menu_action" onClick={() => setExpanded(!expanded)}>
                    <i className="dw-times" />
                  </ButtonLink>

                  <div className="nav_menu-link-not">
                    <h2 className="nav_menu-username">
                      {session.get("user_name")}
                    </h2>

                    <div>
                      <span className="color--is-white opacity--is-75 text-small">
                        Balance:
                        {" "}
                      </span>

                      <span className="color--is-lime text--is-bold">
                        <FormattedDollars value={session.get("money_balance")} />
                      </span>

                      <span className="color--is-white opacity--is-75">
                        {" "}
                        |

                        {" "}
                      </span>

                      <span className="color--is-lime text--is-bold">
                        <FormattedPoints value={session.get("point_balance")} />
                      </span>
                    </div>
                  </div>
                </li>

                <li>
                  <Link className="nav_menu-link" to="/my-games/games-today">
                    <i className="dw-gamepad" />

                    <span>
                      {" "}
                      My Games Dashboard
                    </span>
                  </Link>
                </li>

                <li>
                  <Link className="nav_menu-link" to="/my-account">
                    <i className="dw-user2" />

                    <span>
                      {" "}
                      My Account
                    </span>
                  </Link>
                </li>

                <li>
                  <ButtonLink className="nav_menu-link" onClick={sessionLogout}>
                    <i className="dw-locked" />

                    <span>
                      {" "}
                      Log Out
                    </span>
                  </ButtonLink>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li className="nav_item nav_item--deposit">
          <dl className="nav_balance">
            <dt>
              Balance:
            </dt>

            <dd>
              <div>
                <FormattedDollars value={session.get("money_balance")} />
              </div>

              <div>
                <FormattedPoints value={session.get("point_balance")} />
              </div>
            </dd>
          </dl>

          {depositLink}
        </li>
      </ul>
    </nav>
  );
});
